import type { MapStyleOption } from './types';

export const TEST_ID = 'airspacePage';

// Three map variants all render Natty's airspace overlay (Class B/C/D, LAANC grids,
// SUAs, NSUFR, obstacles, powerlines) on different base layers. Paths are root-
// relative; useResolvedStyle rewrites the sprite URL to absolute at runtime so
// mapbox-gl can fetch it in any deployment environment.
export const MAP_STYLE_OPTIONS: readonly MapStyleOption[] = [
    { id: 'dark', label: 'Dark', path: '/styles/airspace-dark.json' },
    { id: 'light', label: 'Light', path: '/styles/airspace-light.json' },
    { id: 'hybrid', label: 'Hybrid', path: '/styles/airspace-satellite.json' }
] as const;
